import {
  CONTACT_FORM_ERROR,
  SELECT_MODAL_CONTACT,
  LECTURER_SEARCH_FORM_FOCUSED,
  LECTURER_SELECT,
  LECTURER_UNSELECT,
  MODERATOR_SEARCH_FORM_FOCUSED,
  MODERATOR_SELECT,
  MODERATOR_UNSELECT,
  MODERATOR_RESET,
  CLEAR_CONTACT_ERROR_STATE
} from 'constants/ContactModal';

export function contactFormError(error) {
  return {
    type: CONTACT_FORM_ERROR,
    payload: error
  };
}

export function setLecturerFormFocus(isFocused) {
  return {
    type: LECTURER_SEARCH_FORM_FOCUSED,
    payload: isFocused
  };
}

export function setLecturer(contact) {
  return {
    type: LECTURER_SELECT,
    payload: contact
  };
}

export function unsetLecturer(forceUnsetAll) {
  return {
    type: LECTURER_UNSELECT,
    payload: forceUnsetAll
  };
}

export function setModeratorFormFocus(isFocused) {
  return {
    type: MODERATOR_SEARCH_FORM_FOCUSED,
    payload: isFocused
  };
}

export function setModerator(contact) {
  return {
    type: MODERATOR_SELECT,
    payload: contact
  };
}

export function unsetModerator() {
  return {
    type: MODERATOR_UNSELECT
  };
}

export function resetModerator() {
  return {
    type: MODERATOR_RESET
  };
}

export function selectModalContact(contact) {
  return {
    type: SELECT_MODAL_CONTACT,
    payload: contact
  };
}

/**
 * Action to clear any previous contact error on modal state
 */
export function clearContactError() {
  return {
    type: CLEAR_CONTACT_ERROR_STATE
  };
}

export default {
  contactFormError,
  setLecturerFormFocus,
  setModeratorFormFocus,
  setLecturer,
  setModerator,
  unsetModerator,
  unsetLecturer,
  resetModerator,
  selectModalContact,
  clearContactError
};
